module.exports = "select,\nselect option {\n  color: #000000;\n}\n\nselect:invalid,\nselect option[value=\"\"] {\n  color: red;\n}\n\n/*Added for browser compatibility*/\n\n[hidden] {\n  display: none;\n}\n\nimg.d-flex.flex-column.icon-thumb-larger.icon-close.cursor{\n  position: absolute;\n  top:12px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/feature/main/tech-buyer/company-details/company-details.component.css
// module id = ./src/app/feature/main/tech-buyer/company-details/company-details.component.css
// module chunks = main